import {Pipe, PipeTransform} from '@angular/core';
import {isAfter} from 'date-fns';

@Pipe({
  name: 'isAfterDate'
})
export class IsAfterDatePipe implements PipeTransform {

  transform(value: Date | string, compareDate: Date | string): boolean {
    const dateA = typeof value === 'string' ? new Date(value) : value;
    const dateB = typeof compareDate === 'string' ? new Date(compareDate) : compareDate;
    return isAfter(dateA, dateB);
  }

}
